import { lazyLoadView } from '@utils/LazyLoad'
import { FEATURES, SEARCH_GROUPS } from '@constants/Text'

export default [
  {
    path: '/analise_mercado',
    name: 'analise_mercado',
    redirect: '/analise_mercado/geral',
    meta: {
      can_show: FEATURES.CORRETORA,
      search: {
        title: 'Análise de Mercado',
        description: 'Visão de mercado: operacional, financeiro e comercial',
        keywords: [
          'mercado',
          'corretora',
          'operacional',
          'financeiro',
          'comercial',
        ],
        icon: 'analyze-market',
        group: SEARCH_GROUPS.ANALISES,
      },
    },
    component: () =>
      lazyLoadView(import('@modules/corretora/home-corretora.vue')),
    children: [
      {
        path: 'geral',
        name: 'analise_mercado.geral',
        meta: {
          can_show: FEATURES.CORRETORA,
        },
        component: () =>
          lazyLoadView(
            import(
              '@/src/modules/corretora/views/view-visao-geral-corretora.vue'
            )
          ),
      },
      {
        path: 'operacional',
        name: 'analise_mercado.operacional',
        meta: {
          can_show: FEATURES.CORRETORA,
          search: {
            title: 'Mercado — Operacional',
            description: 'Indicadores operacionais da corretora',
            keywords: ['operacional', 'mercado', 'corretora', 'indicadores'],
            group: SEARCH_GROUPS.ANALISES,
          },
        },
        component: () =>
          lazyLoadView(
            import(
              '@/src/modules/corretora/views/operacional-corretora/operacional-corretora.vue'
            )
          ),
      },
      {
        path: 'financeiro',
        name: 'analise_mercado.financeiro',
        meta: {
          can_show: FEATURES.CORRETORA,
          search: {
            title: 'Mercado — Financeiro',
            description: 'Indicadores financeiros da corretora',
            keywords: ['financeiro', 'mercado', 'corretora', 'receita'],
            group: SEARCH_GROUPS.ANALISES,
          },
        },
        component: () =>
          lazyLoadView(
            import(
              '@/src/modules/corretora/views/financeiro-corretora/view-financeiro-corretora.vue'
            )
          ),
      },
      {
        path: 'comercial',
        name: 'analise_mercado.comercial',
        meta: {
          can_show: FEATURES.CORRETORA,
          search: {
            title: 'Mercado — Comercial',
            description: 'Indicadores comerciais da corretora',
            keywords: ['comercial', 'mercado', 'corretora', 'vendas'],
            group: SEARCH_GROUPS.ANALISES,
          },
        },
        component: () =>
          lazyLoadView(
            import(
              '@/src/modules/corretora/views/comercial-corretora/view-comercial-corretora.vue'
            )
          ),
      },
      {
        path: 'analise',
        name: 'analise_mercado.analise',
        meta: {
          can_show: FEATURES.CORRETORA,
          search: {
            title: 'Mercado — Análises',
            description: 'Análises aprofundadas de mercado',
            keywords: ['análises', 'mercado', 'corretora', 'estudos'],
            group: SEARCH_GROUPS.ANALISES,
          },
        },
        component: () =>
          lazyLoadView(
            import(
              '@/src/modules/corretora/views/analises-corretora/view-analises-corretora.vue'
            )
          ),
      },
    ],
  },
]
